export const WEATHER_REPORT_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/weatherReport_v1.0.3.schema.json';
export const WEATHER_REPORT_COMPONENT_TYPE = 'WeatherReport' as const;
